export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-windows-486e9f54b745583a67707068734f4a3e.svg";